import React from "react";
import styled from "@emotion/styled";
import { Step } from "./types";

type StepIndicatorProps = {
  currentStep: Step;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 32px;
`;

const StepCircle = styled.div<{ isActive: boolean; isCompleted: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  background-color: ${({ isActive, isCompleted, theme }) =>
    isActive || isCompleted ? theme.colors.jungle : theme.colors.mist};
  color: ${({ isActive, isCompleted, theme }) =>
    isActive || isCompleted ? theme.colors.snowdrop : theme.colors.cloudDark};
  border: 2px solid
    ${({ isActive, isCompleted, theme }) =>
      isActive
        ? theme.colors.jungleDark
        : isCompleted
        ? theme.colors.jungle
        : theme.colors.mistDark};
`;

const StepConnector = styled.div<{ isCompleted: boolean }>`
  width: 40px;
  height: 2px;
  background-color: ${({ isCompleted, theme }) =>
    isCompleted ? theme.colors.jungle : theme.colors.mist};
  transition: background-color 0.2s ease;

  @media ${({ theme }) => theme.bp.tabletDown} {
    width: 24px;
  }
`;

export const StepIndicator = ({ currentStep }: StepIndicatorProps) => {
  const steps = [1, 2, 3] as const;

  return (
    <Container>
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          <StepCircle
            isActive={currentStep === step}
            isCompleted={currentStep > step}
          >
            {step}
          </StepCircle>
          {index < steps.length - 1 && (
            <StepConnector isCompleted={currentStep > step} />
          )}
        </React.Fragment>
      ))}
    </Container>
  );
};
